import { FunctionComponent, PropsWithChildren } from "react";

import dynamic from "next/dynamic";

import { ZeffyLogoRedirectProps } from "./types";

// Disabled SSR to avoid memory leak caused by makeStyles
export const ZeffyLogoRedirect = dynamic(
  () => import("./ZeffyLogoRedirectSsr").then((mod) => mod.ZeffyLogoRedirectSsr),
  {
    ssr: false,
  }
) as FunctionComponent<PropsWithChildren<ZeffyLogoRedirectProps>>;
